import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// เราจะแยก "tokens" ไว้ในหน่วยความจำ ไม่ persist
export const useSessionStore = create(
  persist(
    (set, get) => ({
      // ===== ข้อมูลที่ "ไม่อ่อนไหว" และอนุญาตให้ persist =====
      profile: null, // { psId, role, username, ...เฉพาะที่ปลอดภัย }
      loggedIn: false,

      // ===== ส่วนอ่อนไหว / ใช้ภายในหน่วยความจำ =====
      appToken: null, // token ของ user หลัง login (หากมี)
      setAppToken: (tk) => set({ appToken: tk }), // ไม่ persist

      // ===== actions =====
      loginSuccess: (safeProfile, maybeToken) => {
        set({
          profile: safeProfile,
          loggedIn: true,
          appToken: maybeToken || null, // ไม่ถูก persist
        });
      },
      logout: () => {
        // reset state
        set({ profile: null, loggedIn: false, appToken: null });
        //  ลบ persist storage
        useSessionStore.persist.clearStorage();
      },

      updateProfile: (partial) => {
        set((state) => ({
          profile: state.profile
            ? { ...state.profile, ...partial }
            : { ...partial },
        }));
      },
    }),
    {
      name: "app_session",
      storage: createJSONStorage(() => localStorage),
      // persist เฉพาะ field ที่ปลอดภัย (profile, loggedIn)
      partialize: (state) => ({
        profile: state.profile,
        loggedIn: state.loggedIn,
      }),
    }
  )
);
